export default "__VITE_ASSET__af0aa64b__"